/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'

import { params } from '../../../../../redux/reducers/reducer'
import { convertFeet } from '../../../../../utils/ConvertFeet'

import LineModel from '../../LineModel'
import DimensionValue from '../../DimensionValue'

const RightLeanToMeasurement = ({ color }) => {
    const frontRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.leanR_p_w) < 9) {
            if((params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanF_p_w, params.leanR_p_w])

    const backRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.leanR_p_w) < 9) {
            if((params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanB_p_w, params.leanR_p_w])

    const [arrowPositions, setArrowPositions] = useState({
        lengthArrowSize: 0,
        lengthArrowPos: [0, 0, 0],
        widthArrowSize: 0,
        leftWidthArrowPos: [0, 0, 0],
        rightWidthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const {
            p_w, leanF_p_w, leanR_p_w, leanR_p_d, leanR_p_h, leanR_p_pos, leanB_p_w, add_right_back_lean_porch, add_right_front_lean_porch, 
        } = params;
        let alignPosOffset = 0;
        let newArrowPositions = {};
        
        if (add_right_back_lean_porch && !add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanR_p_d + leanB_p_w + 0.6,
                lengthArrowPos: [p_w / 2 + leanR_p_w + offset, offset, -leanB_p_w / 2 + alignPosOffset],
                widthArrowSize: leanR_p_w,
                leftWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: leanR_p_h,
                leftHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, -leanR_p_d / 2 - leanB_p_w - arrowOffset + alignPosOffset],
            }

        } else if (!add_right_back_lean_porch && add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanR_p_d + leanF_p_w + 0.6,
                lengthArrowPos: [p_w / 2 + leanR_p_w + offset, offset, leanF_p_w / 2 + alignPosOffset],
                widthArrowSize: leanR_p_w,
                leftWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: leanR_p_h,
                leftHeightArrowPos: [p_w / 2 + leanR_p_w  + offset, 0, leanR_p_d / 2 + leanF_p_w + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
            }
        } else if (add_right_back_lean_porch && add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanR_p_d + leanF_p_w + leanB_p_w + 0.6,
                lengthArrowPos: [p_w / 2 + leanR_p_w + offset, offset, alignPosOffset],
                widthArrowSize: leanR_p_w,
                leftWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: leanR_p_h,
                leftHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, leanR_p_d / 2 + leanF_p_w + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, -leanR_p_d / 2 - leanB_p_w - arrowOffset + alignPosOffset],
            }
        } else {
            newArrowPositions = {
                lengthArrowSize: leanR_p_d + 0.6,
                lengthArrowPos: [p_w / 2 + leanR_p_w + offset, arrowOffset - 0.1, alignPosOffset],
                widthArrowSize: leanR_p_w,
                leftWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [p_w / 2 + leanR_p_w / 2 + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: leanR_p_h,
                leftHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, leanR_p_d / 2 + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [p_w / 2 + leanR_p_w + offset, 0, -leanR_p_d / 2 - arrowOffset + alignPosOffset],
            }
        }

        setArrowPositions(newArrowPositions);
    }, [params.p_w, params.p_d, params.leanR_p_w,  params.leanF_p_w, params.leanB_p_w,  params.leanR_p_d, params.leanR_p_h, params.leanR_p_pos, params.add_right_back_lean_porch, params.add_right_front_lean_porch, params.leantoAlignmentRight]);

    const {
        lengthArrowSize, lengthArrowPos, widthArrowSize,
        leftWidthArrowPos, rightWidthArrowPos, heightArrowSize,
        leftHeightArrowPos, rightHeightArrowPos
    } = arrowPositions;


    return params.add_right_lean && (
        <group name='Measurements-rightLeanto'>
            {/****** length ******/}
            <group name='front-arrow' position={lengthArrowPos} rotation={[0, Math.PI / 2, 0]}>
                <LineModel length={lengthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, - 0.2, 0.5]} rotation={[0, 0, 0]} value={convertFeet((lengthArrowSize-0.6),false) + ' L'} slopeAngle={25} type={'lean'} cmpPos={lengthArrowPos} />
            </group>

            {/****** Width ******/}
            <group name='left-arrow' position={leftWidthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[backRightPosState ? 0 : -0.4, backRightPosState ? 1.5 : 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={convertFeet(widthArrowSize,false) + ' W'} slopeAngle={backRightPosState ? 0 : 25} type={'lean'} cmpPos={leftWidthArrowPos} />
            </group>
            <group name='right-arrow' position={rightWidthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[frontRightPosState ? 0 : 0.4, frontRightPosState ? 1.5 : 0, 0]} rotation={[0, Math.PI / 2, 0]} value={convertFeet(widthArrowSize,false) + ' W'} slopeAngle={frontRightPosState ? 0 : 25} type={'lean'} cmpPos={rightWidthArrowPos} />
            </group>

            {/****** height ******/}
            <group name='left-arrow' position={leftHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.leanR_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.leanR_p_h / 2, -offset]} rotation={[0, 0, 0]} value={convertFeet(heightArrowSize,false) + ' H'} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
            </group>
            <group name='right-arrow' position={rightHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.leanR_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.leanR_p_h / 2, offset]} rotation={[0, Math.PI, 0]} value={convertFeet(heightArrowSize,false) + ' H'} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos} />
            </group>
        </group>
    )
}

export default RightLeanToMeasurement